"use strict";

/**
 * Stores quote data that can be used to:
 *    - Display summary of quote
 *    - Transform data for posting requests
 *    - Transform data for responses
 *
 * @param {UserInputRepository} userInputRepository                        Passed in from services/config.js
 * @param {ServiceResponseRepository} serviceResponseRepository            Passed in from services/config.js
 * @param {Util} Util                                                    Passed in from services/config.js
 * @constructor
 */
function QuoteModel(MODULE_INFO, userInputRepository, serviceResponseRepository, quoteOptions, quoteRequestRepository, Util) {
	var self = this;

	var selectedQuote = quoteOptions.getSelectedQuoteResult();
	var selectedQuoteForPayment = quoteOptions.getSelectedQuoteResultForPayment();
	/**
	 * Retrieves values from UserInputRepository
	 * @param {String} dotSeperatedFieldPath                    Path to value to retrieve
	 * @return {*}                                                Value from UserInputRepository to return
	 * @private
	 */
	this._getUserInputValueFor = function (dotSeperatedFieldPath) {
		var userInput = userInputRepository.get();
		return Util.findHierarchyStringInObject(userInput, dotSeperatedFieldPath, '.');
	}

	/**
	 * Retrieves values from ServiceResponseRepository
	 * @param {String} dotSeperatedFieldPath                    Path to value to retrieve
	 * @return {*}                                                Value from ServiceResponseRepository to return
	 * @private
	 */
	this._getServiceResponseValueFor = function (serviceName, dotSeperatedFieldPath) {
		return serviceResponseRepository.getLastResponseFrom(serviceName);
	}

	/**
	 * Calculates whether at least one driver in the last 4 years, has been charged or convicted of any driving offences
	 * @returns {boolean}
	 * @private
	 */
	this._driversHave_fourYears_licenceRSDC = function () {
		if (this.drivers) {
			var driversLength = this.drivers.length,
				atLeastOneDriverHas = false,
				driver;

			for (var i = 0; i < driversLength; i++) {
				driver = this.drivers[i];

				if (driver.fourYears_licenceRSDC &&
					driver._aggregator.markedForDelete !== true) {
					atLeastOneDriverHas = true;
					break;
				}
			}

			return atLeastOneDriverHas;
		}
	}
	/**
	 *
	 * @returns {boolean}
	 * @private
	 */
	this._driversHave_fourYears_chargedOrConvictedOffences = function () {
		if (this.drivers) {
			var driversLength = this.drivers.length,
				atLeastOneDriverHas = false,
				driver;

			for (var i = 0; i < driversLength; i++) {
				driver = this.drivers[i];

				if (driver.fourYears_chargedOrConvictedOffences &&
					driver._aggregator.markedForDelete !== true
				) {
					atLeastOneDriverHas = true;
					break;
				}
			}

			return atLeastOneDriverHas;
		}
	}
	/**
	 *
	 * @returns {boolean}
	 * @private
	 */
	this._driversHave_fourYears_vehicleAccidentsClaims = function () {
		if (this.drivers) {

			var driversLength = this.drivers.length,
				atLeastOneDriverHas = false,
				driver;

			for (var i = 0; i < driversLength; i++) {
				driver = this.drivers[i];

				if (driver.fourYears_vehicleAccidentsClaims &&
					driver._aggregator.markedForDelete !== true) {
					atLeastOneDriverHas = true;
					break;
				}
			}

			return atLeastOneDriverHas;
		}
	}
	/**
	 *
	 * @returns {boolean}
	 * @private
	 */
	this._driversHave_tenYears_chargedOrConvictedOffences = function () {
		if (this.drivers) {

			var driversLength = this.drivers.length,
				atLeastOneDriverHas = false,
				driver;

			for (var i = 0; i < driversLength; i++) {
				driver = this.drivers[i];

				if (driver.tenYears_chargedOrConvictedOffences &&
					driver._aggregator.markedForDelete !== true) {
					atLeastOneDriverHas = true;
					break;
				}
			}

			return atLeastOneDriverHas;
		}
	}

	this.isReplacementAvailable = function () {

		var selectedCar = serviceResponseRepository.getLastResponseFrom('regoSearch')
		if (selectedCar && selectedCar.modelYear) {
			var modelAge = new Date().getFullYear() - selectedCar.modelYear;
			return (modelAge <= 2);
		}
		return false;
	}

	this.getValidReplacementMonths = function (whenDidYouBuyYear) {
		if (!this.replacementMonths)
			this.replacementMonths = {};

		if (!this.replacementMonths[whenDidYouBuyYear]) {
			if (!whenDidYouBuyYear) {
				return [];
			}

			var monthOptions = moment.months().map(
				function (month, index) {
					var monthIndex = index + 1;
					//add leading zero
					monthIndex = (monthIndex > 9) ? ('' + monthIndex) : ('0' + monthIndex);
					return {
						'label': month,
						'value': monthIndex
					};
				});

			//split month based on year
			var yearsOld = moment().year() - whenDidYouBuyYear;
			if (yearsOld == 0) {
				monthOptions = monthOptions.splice(0, moment().month() + 1);
			} else if (yearsOld > 1) {
				monthOptions = monthOptions.splice(moment().month());
			}
			this.replacementMonths[whenDidYouBuyYear] = monthOptions;
		}

		return this.replacementMonths[whenDidYouBuyYear];
	}

	this.getValidReplacementYears = function () {
		if (!this.replacementYears) {
			var yearOptions = [];
			//get start year by subtracting 2 years
			var startYear = moment().subtract(2, 'years').year();
			var currentYear = moment().year();
			for (var i = startYear; i <= currentYear; i++) {
				yearOptions.push({
					'label': i,
					'value': i
				});
			}
			this.replacementYears = yearOptions;
		}

		return this.replacementYears;
	}

	this.email = this._getUserInputValueFor('vehicleForm.tellUsABitMore.yourEmailAddress') ? this._getUserInputValueFor('vehicleForm.tellUsABitMore.yourEmailAddress') : this._getUserInputValueFor('email');

	// vehicle form data
	this.vehicleForm = this._getUserInputValueFor('vehicleForm');

	// cover type
	this.selectedQuote = selectedQuote;
	this.selectedQuoteForPayment = selectedQuoteForPayment;
	//  this._getServiceResponseValueFor('quickQuote');
	if (selectedQuote) {
		this.annualCoverType = selectedQuote.getAnnual();
		this.monthlyCoverType = selectedQuote.getMonthly();
		// this.fortnightlyCoverType = selectedQuote.getMonthly();

		this.quoteResult = this.selectedQuoteForPayment; // selectedQuote.getQuoteResult();
		if (this.quoteResult) {
			this.coverageOptions = this.quoteResult.coverageOptions;
			if (this.coverageOptions) {
				this.coverageOptionsToShow = this.coverageOptions.filter(function (op) {
					return op.required === false;
				});
				this.hasCoverageOptions = this.coverageOptionsToShow.length > 0;
			}
			this.excess = this.quoteResult.excess;
			this.namedDriverExcess = findNamedDriverExcess();
		}
	}

	/** excess list to be displayed in the quote panel */
	this.displayableExcessList = null;

	this.getDisplayableExcess = function () {
		if (!this.excess)
			return [];

		if (!this.displayableExcessList) {
			var filterOut = ['voluntaryVehicleExcessOptions', 'voluntaryVehicleExcess', 'standardVehicleExcess'];
			this.displayableExcessList = [];

			for (var key in this.excess) {
				if (filterOut.indexOf(key) === -1)
					this.displayableExcessList.push({
						key: key,
						excessValue: this.excess[key]
					});
			}
		}

		return this.displayableExcessList;
	}

	function findNamedDriverExcess() {
		var namedDriverExcess = [],
			qr = selectedQuoteForPayment ? selectedQuoteForPayment.response : null;

		if (qr && qr.vehicles) {
			var drivers = qr.vehicles[0].drivers;
			drivers.forEach(function (driver) {
				if (driver.driver &&
					driver.driver.calculatedExcess &&
					driver.driver.calculatedExcess > 0) {
					namedDriverExcess.push({
						firstName: driver.driver.person.firstName,
						lastName: driver.driver.person.lastName,
						excessValue: driver.driver.calculatedExcess,
						dob: driver.driver.person.dateOfBirth
					});
				}
			});
		}

		return namedDriverExcess;
	}


	/**
	 * Excluded drivers
	 */
	var savedQuoteResult = this._getServiceResponseValueFor('quote');
	if (savedQuoteResult && savedQuoteResult.vehicles && savedQuoteResult.vehicles[0]) {
		/** excluded driver condition to be correctly diagnosed here */
		// this.excludedDrivers = this.quoteResult.excludedDrivers ;
		var excludedDrivers = [];

		savedQuoteResult.vehicles[0].drivers.forEach(function (driver) {
			if (driver.driverUsage == 'excluded')
				excludedDrivers.push(driver.driver.person);
		})
		this.excludedDrivers = excludedDrivers;
	}


	this.hasExcludedDrivers = function () {
		return this.excludedDrivers && this.excludedDrivers.length > 0;
	}

	this.drivers = [];
	this.postCode = null;
	this.campaignCode = null;
	if (this.vehicleForm) {
		//TODO: set regoNumber based on step 1 or step 4

		// vehicleDetails
		if (this.vehicleForm.carDetails) {
			this.carDetailsUsage = this.vehicleForm.carDetails.primaryCarUse;
			switch (this.carDetailsUsage) {
				case 'commercial':
					this.carDetailsUsage += ' - ' + this.vehicleForm.carDetails.commercialActivityType.label;
					break;
				case 'business':
					this.carDetailsUsage += ' - ' + this.vehicleForm.carDetails.businessActivityType.label;
					break;
			}
		}

		if (this.vehicleForm.getStarted && this.vehicleForm.getStarted.personOrCompany) {
			this.policyStartDate = this.vehicleForm.getStarted.policyStartDate,
				this.personOrCompany = this.vehicleForm.getStarted.personOrCompany;
		}

		// Main drivers & additional drivers
		this.additionalDrivers = [];

		if (this.vehicleForm.driver) {
			var drivers = this.vehicleForm.driver.drivers;
			if (drivers) {

				this.mainDriver = drivers[0];

				if (drivers.length > 1) {
					this.additionalDrivers = drivers.splice(1, drivers.length);
				}
			}
		}

		// drivers
		if (this.mainDriver) {
			this.drivers = [this.mainDriver];
			this.noClaimBonus = this.mainDriver.noClaimBonus;
		}
		if (this.additionalDrivers) {
			this.drivers = this.drivers.concat(this.additionalDrivers);
		}

		// address
		var aboutYourCar = this.vehicleForm.aboutYourCar;
		if (aboutYourCar && aboutYourCar.address) {
			this.address = aboutYourCar.address;
			this.postCode = this.address.postalCode;
			this.state = this.address.state;
		}

		if (this.vehicleForm.promotionalCode) {
			this.campaignCode = this.vehicleForm.promotionalCode.promotionalCode;
		}

		// rego details
		this.regoDetails = this._getServiceResponseValueFor('regoSearch');

		if (aboutYourCar && aboutYourCar.regoDetails) {
			this.regoNumber = aboutYourCar.regoDetails.regoNumber;
		} else if (this.vehicleForm.tellUsYourRegoNumber &&
			this.vehicleForm.tellUsYourRegoNumber.regoNumber && !this.vehicleForm.aboutYourCar.retrievedQuoteRego) {
			this.regoNumber = this.vehicleForm.tellUsYourRegoNumber.regoNumber;
		}

		if (this.regoDetails) {
			this.vehicleOptionalEquipments = this.regoDetails.optionalEquipments;
		}


	}

	// this.quoteId = this._getServiceResponseValueFor('service-name', 'quote.quoteId');
	this.quoteId = null;
	if (quoteRequestRepository.getSelectedQuoteCredentials())
		this.quoteId = quoteRequestRepository.getSelectedQuoteCredentials().quoteID;


	/** Google Tag Manager data **/
	this.gtmPolicyHolder = this.mainDriver ? this.mainDriver.person : null;
	this.gtmTransactionAffiliation = 'QBE Direct';
	this.insuranceType = MODULE_INFO.insuranceType;
	this.productCode = MODULE_INFO.productCode;
}
